export * from './horizontal-scroll.interfaces';
export { default } from './horizontal-scroll.hooks';
